// //TODO 类型  异常处理等
// export function setLocalstorage(index,value) {
//     localStorage.setItem(index,JSON.stringify(value));
// }

// export function getLocalstorage(index) {
//     let item = localStorage.getItem(index);
//     return JSON.parse(item);
// }

// export function removeLocalstorage(index) {
//     localStorage.removeItem(index);
// }
import Cookies from 'js-cookie'

// const userKey = 'user';

export function setCache (index, value) {
  // return Cookies.set(index, value)
}

export function getCache (index) {
  // TODO
  // let result = Cookies.get(index)
  // try {
  //   return result && JSON.parse(result)
  // } catch (error) {
  //   console.log('getCache JSON.parse error: ', error)
  //   return result
  // }
}

export function removeCache (index) {
  return Cookies.remove(index)
}
